import React, { ReactNode } from "react"

import Container from "@ecom/ui/components/Container"
import Grid from "@ecom/ui/components/Grid"
import { AppLinkMui } from "@ecom/ui/components/AppLink"
import Button from "@material-ui/core/Button"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import clsx from "clsx"
import HalvaQuestion from "./img/halvaQuestion"
import Halva from "./img/halva"
import HalvaPurple from "./img/halvaShapka"

import * as styles from "./twoChoice.module.scss"
import scrollToPersonalForm from "../../helpers/scrollToPersonalForm"
import HalvaCheckRed from "./img/halvaCheckRed"
import HalvaQuestionBlue from "./img/halvaQuestionBlue"

type AboutHalvaProps = {
  orderNum?: string
  newYear?: boolean
  textBlockTitle?: ReactNode
  title?: ReactNode
  secondTextBlockTitle?: ReactNode
  variant?:
    | "standart"
    | "shapka"
    | "kiberponedelnik"
    | "1500bonus"
    | "newYearMediaRuby"
    | "genderAction"
    | "nedeliUmnyhRassrochek"
    | "backtoschool"
    | "samoletik"
    | "cashback_factory"
    | "cashback100"
    | "schoolAction"
  swapCard?: boolean
  swapCardText?: boolean
  swapBtnText?: boolean
}

const handleClick = () => {
  scrollToPersonalForm()

  pushToDataLayer({
    event: "buttonClick",
    name: "Оформить карту",
    placement: "third_screen_button_halva",
  })
}

const handleClickLink = () => {
  pushToDataLayer({
    event: "buttonClick",
    name: "Регистрация",
    placement: "third_screen_button_halva",
  })
}

const handleClickShapka = () => {
  const map = document.getElementById("map")
  if (map) {
    map.scrollIntoView({ behavior: "smooth", block: "center" })
  }
  pushToDataLayer({
    event: "buttonClick",
    name: "Ждем тебя в «Шапке»! ",
    placement: "map_halva",
  })
}

const handleClickKiberponedelnik = () => {
  pushToDataLayer({
    event: "buttonClick",
    name: "twist",
    placement: "wheel_of_fortune",
  })
}

export function TwoChoice({
  orderNum,
  newYear = false,
  textBlockTitle = <>Есть «Халва» - регистрируйся в&nbsp;акции прямо сейчас!</>,
  secondTextBlockTitle = (
    <>Нет «Халвы» - оформляй карту и после получения не забудь зарегистрироваться в акции</>
  ),
  title = false,
  variant = "standart",
  swapCard = false,
  swapCardText = false,
  swapBtnText = false,
}: AboutHalvaProps) {
  const cardText = swapCardText ? secondTextBlockTitle : textBlockTitle
  const secondCardText = swapCardText ? textBlockTitle : secondTextBlockTitle
  function CtaLinkFirstCard() {
    if (newYear) {
      return (
        <AppLinkMui
          href="https://halvapoly.halva.games/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnNY}
          underline="none"
          onClick={handleClickLink}
        >
          Играть
        </AppLinkMui>
      )
    }
    if (variant === "shapka") {
      return (
        <Button className={styles.btnPurple} onClick={handleClickShapka}>
          Ждем тебя в «Шапке»!
        </Button>
      )
    }
    if (variant === "kiberponedelnik") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/keshbek-do-100-za-pokupki"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
          onClick={handleClickKiberponedelnik}
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "cashback_factory") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/cashback-factory"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
        >
          Активировать
        </AppLinkMui>
      )
    }
    if (variant === "1500bonus") {
      return (
        <Button className={styles.btn} onClick={handleClick}>
          Оформить карту
        </Button>
      )
    }
    if (variant === "genderAction") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/shops/actions/keshbek-do-100-na-podarki-lyubimym"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
          onClick={handleClickKiberponedelnik}
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "schoolAction") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/bolshie-peremeny-s-keshbekom-i-rassrochkoj"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
          onClick={handleClickKiberponedelnik}
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "backtoschool") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/podarki-lyubimym"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "samoletik") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/bumazhnyj-samoletik"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "cashback100") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/all/keshbek-do-100-ko-dnyu-semi"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
        >
          Активировать
        </AppLinkMui>
      )
    }

    if (variant === "nedeliUmnyhRassrochek") {
      return (
        <AppLinkMui
          href="https://halvacard.ru/actions/uvelichennaya-rassrochka-i-keshbek/umnye-nedeli"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btnMain}
          underline="none"
          onClick={handleClickKiberponedelnik}
        >
          Активировать
        </AppLinkMui>
      )
    }

    return (
      <AppLinkMui
        href="https://halvacard.ru/shops/actions/otkryvaem-shubohranilishe"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.btn}
        underline="none"
        onClick={handleClickLink}
      >
        Регистрация
      </AppLinkMui>
    )
  }

  function CtaLinkSecondCard() {
    if (variant === "1500bonus") {
      return (
        <AppLinkMui
          href="https://go.halvacard.ru/email/web_invite_friend_lim/"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.btn}
          underline="none"
          onClick={handleClickLink}
        >
          Привести друга
        </AppLinkMui>
      )
    }

    return (
      <Button onClick={handleClick} className={styles.btn}>
        {swapBtnText ? "Привести друга" : "Оформить карту"}
      </Button>
    )
  }

  const setFirstCardImage = () => {
    switch (variant) {
      case "shapka":
        return <HalvaPurple alt="bg image" className={styles.img} />

      case "standart":
        return <Halva alt="bg image" className={styles.img} />

      case "1500bonus":
        return <Halva alt="bg image" className={styles.img} />

      case "kiberponedelnik":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "backtoschool":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "samoletik":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "cashback100":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "cashback_factory":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "newYearMediaRuby":
        return <HalvaCheckRed alt="bg image" className={styles.img} />

      case "genderAction":
        return <HalvaCheckRed alt="bg image" className={styles.img} />
      case "schoolAction":
        return <HalvaCheckRed alt="bg image" className={styles.img} />
      case "nedeliUmnyhRassrochek":
        return <HalvaCheckRed alt="bg image" className={styles.img} />
      default:
        return null
    }
  }

  const setSecondCardImage = () => {
    switch (variant) {
      case "newYearMediaRuby":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "kiberponedelnik":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "backtoschool":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "samoletik":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "cashback100":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "cashback_factory":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "genderAction":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      case "nedeliUmnyhRassrochek":
        return <HalvaQuestionBlue alt="bg image" className={styles.img} />
      default:
        return <HalvaQuestion alt="bg image" className={styles.img} />
    }
  }

  return (
    <section
      data-exclude={orderNum}
      className={clsx(styles.section, styles[variant])}
      id="TwoChoice"
    >
      <Container className={styles.container}>
        {title && (
          <h2 className={clsx({ [styles.kiberponedelnik]: variant === "kiberponedelnik" })}>
            {title}
          </h2>
        )}
        <Grid container className={clsx(styles.gridContainer, swapCard && styles.swapCard)}>
          <Grid sm={12} md={6} className={clsx(styles.firstCard, styles[variant])}>
            <div className={styles.content}>
              <div className={clsx(styles.textBlock, styles[variant])}>{cardText}</div>
              {CtaLinkFirstCard()}
            </div>
            {setFirstCardImage()}
          </Grid>
          <Grid sm={12} md={6} className={clsx(styles.secondCard, styles[variant])}>
            <div className={styles.content}>
              <div className={clsx(styles.textBlock, styles[variant])}>{secondCardText}</div>
              {CtaLinkSecondCard()}
            </div>
            {setSecondCardImage()}
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}
